<template>
    <div class="page_hxbanner flex-col">
        <div class="group_10 flex-row">
            <div class="group_11 flex-col">
                <div class="section_3 flex-row" :style="{ backgroundImage: `url(${imageUrl})` }">
                    <div class="section_15 flex-col justify-between">
                        <div class="text-group_18 flex-col">
                            <span class="text_54">自研3C企业健康管理服务体系</span>
                            <span class="text_55">核心业务</span>
                        </div>
                        <img
                                class="image_2"
                                referrerpolicy="no-referrer"
                                src="../../../assets/advisory/advisory_line_01.png"
                        />
                    </div>
                    <!--
                    <div class="section_16 flex-col">
                        <div class="text-wrapper_2">
                            <span class="text_10">C</span>
                            <span class="text_11">hannel</span>
                        </div>
                        <div class="text-wrapper_3">
                            <span class="text_12">C</span>
                            <span class="text_13">ompliance</span>
                        </div>
                        <div class="text-wrapper_4">
                            <span class="text_14">C</span>
                            <span class="text_15">onsultation</span>
                        </div>
                    </div>

                    <div class="section_17 flex-col">
                        <div class="block_1 flex-col"></div>
                        <div class="block_2 flex-col"></div>
                        <div class="block_3 flex-col"></div>
                    </div>
                    -->
                    <!--
                    <img
                            class="image_3"
                            referrerpolicy="no-referrer"
                            src="../../../assets/advisory/advisory_bc_01.png"
                    />
                    <img
                            class="image_4"
                            referrerpolicy="no-referrer"
                            src="../../../assets/advisory/advisory_line_02.png"
                    />
                    <img
                            class="image_5"
                            referrerpolicy="no-referrer"
                            src="../../../assets/advisory/advisory_line_03.png"
                    />
                    <img
                            class="image_6"
                            referrerpolicy="no-referrer"
                            src="../../../assets/advisory/advisory_line_04.png"
                    />
                    -->
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    export default {
        props: {
            imageUrl: {
                type: String,
                required: true
            }
        },
        data() {
            return {
               // aboutBanner: require('@/assets/advisory/advisory_bj_02.png'),
            };
        },
        methods: {}
    };
</script>

<style scoped lang="css"  >
    .page_hxbanner {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .group_10 {
        width: 100%;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .group_11 {
        position: relative;
        width: 100%;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .section_3 {
        background-image: url(../../../assets/advisory/advisory_bj_02.png);
        background-size: cover; /* 新增背景尺寸控制 */
        background-position: center; /* 新增背景定位 */
        background-repeat: no-repeat;
        width: 100% !important; /* 强制宽度100% */
        height: 450px; /* 保持固定高度 */
        position: relative;
    }

    .section_15 {
        width: 416px;
        height: 147px;
        margin: 160px 0 0 134px;
    }

    .text-group_18 {
        position: relative;
        width: 416px;
        height: 131px;
    }

    .text_54 {
        width: 450px;
        height: 70px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 0.6);
        font-size: 32px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: left;
        line-height: 70px;
        margin-top: 61px;
    }

    .text_55 {
        position: absolute;
        left: 0;
        top: 0;
        width: 174px;
        height: 70px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 44px;
        font-family: AlibabaPuHuiTi_3_85_Bold;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 70px;
    }

    .image_2 {
        width: 100px;
        height: 2px;
        margin: 14px 0 0 65px;
    }

    .section_16 {
        width: 106px;
        height: 242px;
        margin: 99px 0 0 290px;
    }

    .text-wrapper_2 {
        width: 71px;
        height: 40px;
        overflow-wrap: break-word;
        font-size: 0;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
        margin-left: 1px;
    }

    .text_10 {
        width: 71px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
    }

    .text_11 {
        width: 71px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        line-height: 40px;
    }

    .text-wrapper_3 {
        width: 99px;
        height: 40px;
        overflow-wrap: break-word;
        font-size: 0;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 40px;
        margin: 55px 0 0 1px;
    }

    .text_12 {
        width: 99px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
    }

    .text_13 {
        width: 99px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        line-height: 40px;
    }

    .text-wrapper_4 {
        width: 106px;
        height: 40px;
        overflow-wrap: break-word;
        font-size: 0;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 40px;
        margin-top: 67px;
    }

    .text_14 {
        width: 106px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
    }

    .text_15 {
        width: 106px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        line-height: 40px;
    }

    .section_17 {
        width: 8px;
        height: 211px;
        margin: 119px 0 0 16px;
    }

    .block_1 {
        background-color: rgba(255, 255, 255, 0.6);
        border-radius: 50%;
        width: 8px;
        height: 8px;
    }

    .block_2 {
        background-color: rgba(255, 255, 255, 0.6);
        border-radius: 50%;
        width: 8px;
        height: 8px;
        margin-top: 88px;
    }

    .block_3 {
        background-color: rgba(255, 255, 255, 0.6);
        border-radius: 50%;
        width: 8px;
        height: 8px;
        margin-top: 99px;
    }

    .image_3 {
        width: 275px;
        height: 254px;
        margin: 98px 145px 0 78px;
    }

    .image_4 {
        position: absolute;
        left: 966px;
        top: 123px;
        width: 187px;
        height: 39px;
    }

    .image_5 {
        position: absolute;
        left: 966px;
        top: 219px;
        width: 134px;
        height: 64px;
    }

    .image_6 {
        position: absolute;
        left: 966px;
        top: 326px;
        width: 263px;
        height: 4px;
    }
</style>
